//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as myPersonalityAction from '../action/myPersonalityAction';
//Material-ui
import Button from '@material-ui/core/Button';

//Part
import PartPageTitle from './PartPageTitle';


//Icon

//JSON
var personalityItem = require('../data/personality.json');


const shuffle = ([...array]) => {
  for (let i = array.length - 1; i >= 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

class Comp extends React.Component {
  constructor(props) {
		super(props);
    const question = personalityItem.question;
    let questionEI = question.filter((value) => value.type === 'EI');
    questionEI.splice(Math.floor( Math.random () * 7), 1);
    let questionSN = question.filter((value) => value.type === 'SN');
    questionSN.splice(Math.floor( Math.random () * 7), 1);
    let questionTF = question.filter((value) => value.type === 'TF');
    questionTF.splice(Math.floor( Math.random () * 7), 1);
    let questionJP = question.filter((value) => value.type === 'JP');
    questionJP.splice(Math.floor( Math.random () * 7), 1);

    let questionEISN = questionEI.concat(questionSN);
    let questionEISNTF = questionEISN.concat(questionTF);
    let questionEISNTFJP = questionEISNTF.concat(questionJP);
    let questionShuffle = shuffle(questionEISNTFJP);
    let question28 = questionShuffle.map((value, index) => {
      return ({...value, answer: null});
    })

    this.state = {
      question28: question28,
      alertVisible: false,
      questionVisibleIndex: 0,
    }
	}

  componentDidMount() {
    document.title = '性格診断テスト - パートナーズ';
  }

  _answerAdd(index, value) {
    let nextState = Object.assign([], this.state.question28);

		nextState[index].answer = value;
    this.setState({
      question28: nextState,
      questionVisibleIndex: (this.state.questionVisibleIndex + 1),
    });
  }

  _saveSubmit() {
    let c = 0;
    let pointEI = 0;
    let pointSN = 0;
    let pointTF = 0;
    let pointJP = 0;

    for (var i = 0; i < this.state.question28.length; i++) {
      let value =  this.state.question28[i];
      let point = 0;
      if (value.answer === 'yes') {
        point = value.yes;

      }
      else if (value.answer === 'no') {
        point = value.no;

      }
      else {
        let elem = document.getElementById('question-' + i);
        if (elem) {
          let rect = elem.getBoundingClientRect();
          window.scrollTo(0, (window.pageYOffset + rect.top - document.getElementById('header_menu').clientHeight));
        }
        this.setState({alertVisible: true});
        break;
      }

      if (value.type === 'EI') {
        pointEI = pointEI + point;
      }
      else if (value.type === 'SN') {
        pointSN = pointSN + point;
      }
      else if (value.type === 'TF') {
        pointTF = pointTF + point;
      }
      else if (value.type === 'JP') {
        pointJP = pointJP + point;
      }
      c++;
    }

    if (c === 28) {
      this.props.myPersonalitySave(pointEI, pointSN, pointTF, pointJP,
        () => this.props.history.push('/my/personality/')
      )
    }
  }

  _renderList(index, question, answer) {

    let selectColor = {
      borderColor:'#CD4695',
      backgroundColor:'#E7B0D0',
      textColor:'#5D0036',
      fontSize:'1.1em',
      margin: '10px',
    }

    let basicColor = {
      borderColor:'#999',
      backgroundColor:'#FFF',
      textColor:'#333',
      fontSize:'1.1em',
      margin: '10px',
    }

  	return (
      <div
        className='round12'
        style={{
          display: (this.state.questionVisibleIndex === index ? '' : 'none'),
          margin: '15px',
          padding: '10px',
          background: '#FFF',
          borderStyle:'solid',
          borderWidth:'1px',
          borderColor:'#E5E5E5',
        }}
        id={ 'question-' + index }
        key={ index }
      >
        <div>
          <span className='white_icon'>{index + 1}問</span>
          <div style={{fontSize:'1.2em'}}>{ question }</div>
        </div>
        <div align='center'>
          <Button
            variant="outlined"
            style={
              (answer === 'yes') ?
              selectColor :
              basicColor
            }
            onClick={ () => this._answerAdd(index, 'yes') }
          >
            はい
          </Button>
          <Button
            variant="outlined"
            style={
              (answer === 'no') ?
              selectColor :
              basicColor
            }
            onClick={ () => this._answerAdd(index, 'no') }
          >
            いいえ
          </Button>
        </div>


      </div>
  	)
  }


  render() {

    let noAnswer = this.state.question28.filter(item => item.answer === null);

    return (
      <div>
        <PartPageTitle
          title={'性格診断'}
          onback={ '/my/' }
        />

        <h2 align='center'>28問の質問に回答して下さい</h2>
        <div style={{maxWidth:'600px', margin:'auto'}}>
          {
            this.state.question28.map((value, index) => (
              this._renderList(index, value.question, value.answer)
            ))
          }
          {
            (this.state.questionVisibleIndex > 0) && (
              <div style={{margin: '15px'}}>
                <Button
                  variant="outlined"
                  size='small'
                  onClick={ () => this.setState({questionVisibleIndex: (this.state.questionVisibleIndex - 1) }) }
                >
                  戻る
                </Button>
              </div>
            )
          }

          {
            (noAnswer.length === 0) && (
              <div style={{maxWidth:'400px', width:'100%', margin:'auto'}}>
                <div style={{padding:'15px'}}>
                  <Button
                    variant="contained"
                    color='primary'
                    onClick={ () => this._saveSubmit() }
                    style={{width: '100%', fontSize:'1.2em'}}
                  >
                    診断結果を見る
                  </Button>
                </div>
              </div>
            )
          }
        </div>
      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...myPersonalityAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
